import React from 'react';
import { Icon } from 'semantic-ui-react';
import moment from 'moment-timezone';

import useCopyToClipboard from '@src/hooks/CopyToClipboard';
import { styled } from '@modules/common/components/ThemeProvider/utils';
import { getDaysString } from '@src/lib/date';
import { AccordionTitle } from '@modules/common/components/Accordion';
import config from '@config/config';
import { StyledTitle } from '@modules/auth/widgets/OAuthClient/ExistingClients/style';

import { OAuthClientDescriptor } from '../../../components/types/oauth-client';
import SPAInfo from './SPAInfo';

type Props = {
  client: OAuthClientDescriptor;
};

function DeletedClient({ client }: Props) {
  const { isCopied, copyToClipboard } = useCopyToClipboard();
  const expiryDate = client.expiryDate && moment.utc(client.expiryDate);
  return (
    <>
      <AccordionTitle key={client.clientId}>
        <StyledClientInfo>
          <StyledNameAndId>
            <StyledTitle>{client.name}</StyledTitle>
            <div>
              <b>ID:</b> <StyledClientId>{client.clientId}</StyledClientId>
              <Icon
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation();
                  copyToClipboard(client.clientId);
                }}
                name={isCopied ? 'thumbs up' : 'copy'}
                color={isCopied ? 'green' : undefined}
                style={{ cursor: 'pointer', marginLeft: '0.75rem' }}
              />
            </div>
          </StyledNameAndId>

          {config.oAuthClientsExpiryEnabled && expiryDate && expiryDate.isBefore(moment.utc()) && (
            <StyledAdditionalInfo>
              <b>Expired on</b>: {expiryDate.format('DD MMMM YYYY, HH:mm (UTC)')}{' '}
              {getDaysString(expiryDate.toDate())}
            </StyledAdditionalInfo>
          )}
          <SPAInfo client={client} />
        </StyledClientInfo>
      </AccordionTitle>
    </>
  );
}

export default DeletedClient;

const StyledClientInfo = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: auto;
`;

const StyledNameAndId = styled('div')``;

const StyledAdditionalInfo = styled('div')`
  margin-top: 1rem;
`;

const StyledClientId = styled('code')`
  min-width: 295px;
`;
